import { useState } from 'react'
import { Autocomplete } from '@mui/material'
import { Chip, TextField } from '@mui/material'
import { SecureFileEditIcon } from '../../icon'
import { UtilityService } from '../../services/UtilityService'

interface Props {
    FaceList?: any;
    Accesslist?: any;
    PlaceHolder?: string;
    AddAccessListHandel?: (list) => void;
    AddFaceAccesListHandle?: (list) => void;
}

const AddAccessListTextComponent = (props: Props) => {
    // const [inputEmailValue, setInputEmailvalue] = useState<any>("")
    const [addAccessList, setAddAccessList] = useState<string[]>(props.Accesslist || [])
    const [email, setEmail] = useState<string>("")


    const EmailhandleBlur = (e) => {

        if (!!e?.target?.value) {


            if (!addAccessList.find(x => x.trim() === e?.target?.value.trim())) {
                setEmail("")
                const data = [...addAccessList, e.target.value]
                setAddAccessList(data)
                props.AddAccessListHandel(data)
            }
            // setInputEmailvalue("")
        }
    }

    const onEmailHandleChange = (e, value) => {
        let emails = value.map(x => x.trim())
        setAddAccessList(emails)
        props.AddAccessListHandel(emails)
        setEmail("")
    }

    // const EmailHandleinputChange = (e, value) => {
    //     setInputEmailvalue(value)
    // }

    return (
        <>
            <div className='d-flex align-end justify-between'>
                <div className='w-p-90'>
                    <Autocomplete
                        multiple
                        freeSolo
                        fullWidth
                        disableClearable
                        options={[]}
                        className='field-border'
                        value={addAccessList}
                        onChange={(e, value) => onEmailHandleChange(e, value)}
                        // inputValue={inputEmailValue}
                        // onInputChange={EmailHandleinputChange}
                        renderTags={(value, getTagProps) =>
                            value?.map((option, index) => (
                                <Chip
                                    classes={{
                                        colorPrimary: UtilityService.isValidEmail(option) ? "custom-color-chip-1" : "custom-color-chip-4"
                                    }}
                                    color={"primary"}
                                    label={option}
                                    {...getTagProps({ index })}
                                />
                            ))
                        }
                        onBlur={(e) => EmailhandleBlur(e)}
                        renderInput={(params) => (
                            <TextField
                                {...{ ...params, inputProps: { ...params.inputProps, value: email } }}
                                onChange={(e) => setEmail(e.target.value)}
                                variant="standard"
                                placeholder={addAccessList?.length > 0 ? "" : "Add mail access:"}
                            />
                        )}
                    />
                </div>
                <SecureFileEditIcon />
            </div>
        </>
    )
}
export default AddAccessListTextComponent